import { IClientComponentDefinition } from '@glidecms/deliver-core-dev/gd-module'

export const VerticalSubVerticalLinksCCD: IClientComponentDefinition = {
  name: 'verticalSubVerticalLinks',
  load: () => import(/* webpackChunkName: 'verticalSubVerticalLinks' */ './index'),
}
